<template>
  <div id="myMinigame">
    <div style="width: 100%;height: calc(100vh - 60px);padding-bottom: 80px">
      <iframe frameborder="0" :src="gameBaseUrl" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myMinigame',
  data () {
    return {
      gameBaseUrl: process.env.config.gameUrl
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myPkFit/myMinigame.vue